export const getPropertyCreatorName = (userId: string) =>
  `TagAppStateTransformer_${userId}`;
